import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconArrowLeftSlide, IconArrowRightSlide, IconGooglePlay, IconappStore } from '@/components/icons/MainIcons';
import { getApiBaseUrl, getStorageUrl } from '@/utils/utils';

interface SocialLink {
    link: string;
    platform: string;
}

interface SliderData {
    id: number;
    description: string;
    image: string;
    title: string;
    social_links: SocialLink[];
}

const FooterPanel = () => {
    const { t } = useTranslation();
    const [dataPanel, setDataPanel] = useState<SliderData[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        fetch(`${getApiBaseUrl()}/slider_banner`)
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data.data)) {
                    setDataPanel(data.data);
                } else {
                    console.error('Error: data.data is not an array', data);
                    setDataPanel([]);
                }
            })
            .catch((error) => console.error('Error fetching Footer data:', error));
    }, []);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % dataPanel.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + dataPanel.length) % dataPanel.length);
    };

    console.log('dataPanell', dataPanel);

    return (
        <div>
            <div className="mainContainer w-full">
                <div className="flex items-center justify-center relative w-full">
                    {dataPanel.length > 0 && (
                        <div className="lg:mb-[96px] md:mb-[75px] mb-[50px] md:mt-[88px] mt-[84px] flex items-center justify-center relative w-full">
                            {/* Prev */}
                            <button
                                onClick={handlePrev}
                                className="arrowSlideFooter absolute lg:-left-[27px] md:-left-[23px] left-[0px]"
                            >
                                <IconArrowLeftSlide className="iconArrow" />
                            </button>

                            <div className="footerImg w-full grid lg:grid-cols-2 grid-cols-1 overflow-hidden gap-3">
                                <div className="py-[55px] flex flex-col xl:px-[50px] lg:px-[36px] md:px-[45px] sm:px-[50px] px-[18.5px] relative w-full text-center lg:text-right">
                                    <h3
                                        className="leading-[1] headFooter w-full text-Grey20"
                                        dangerouslySetInnerHTML={{ __html: dataPanel[currentIndex].title }}
                                    />

                                    {/* {t('footer.download')}
                                <span className="text-aman-txt"> {t('footer.aman')} </span>
                                <span className="sm:inline hidden"> {t('footer.now')}</span> */}

                                    <p className="md:text-[24px] text-[20px] font-medium text-Grey20 md:mt-[20px] mt-[16px] xl:mb-[111px] lg:mb-[105px] md:mb-[90px] sm:mb-[70px] mb-[48px]">
                                        {dataPanel[currentIndex].description}
                                    </p>

                                    <div className="flex xl:gap-4 lg:gap-[14px] md:gap-4 gap-[13px] lg:mx-0 mx-auto mt-auto">
                                        <button
                                            className="mainRounded dark:bg-main bg-Grey20 md:px-[30px] sm:px-[25px] px-[16px] md:py-[12px] sm:py-[10px] py-[5px] head-border cursor-pointer hover:shadow-2xl transition-shadow duration-200"
                                            onClick={() => {
                                                const appStoreLink =
                                                    dataPanel[currentIndex]?.social_links?.find(
                                                        (link) => link.platform === 'google_play',
                                                    )?.link || '#';

                                                if (appStoreLink !== '#') {
                                                    window.open(appStoreLink, '_blank');
                                                } else {
                                                    console.log('رابط App Store غير متوفر');
                                                }
                                            }}
                                        >
                                            <IconappStore className="dark:text-white text-main lg:w-[150px] md:w-[145px] sm:w-[115px] w-[100px]" />
                                        </button>
                                        <button
                                            className="mainRounded dark:bg-main bg-Grey20 xl:px-[50px] lg:px-[43px] md:px-[39px] sm:px-[28px] px-[23px] md:py-[12px] sm:py-[10px] py-[5px] head-border cursor-pointer hover:shadow-2xl transition-shadow duration-200"
                                            onClick={() => {
                                                const appStoreLink =
                                                    dataPanel[currentIndex]?.social_links?.find(
                                                        (link) => link.platform === 'app_store',
                                                    )?.link || '#';

                                                if (appStoreLink !== '#') {
                                                    window.open(appStoreLink, '_blank');
                                                } else {
                                                    console.log('رابط App Store غير متوفر');
                                                }
                                            }}
                                        >
                                            <IconappStore className="dark:text-white text-main lg:w-[150px] md:w-[145px] sm:w-[115px] w-[100px]" />
                                        </button>
                                    </div>
                                </div>

                                <div className="lg:flex hidden items-end justify-end px-2 h-full pt-[55px]">
                                    <img
                                        src={getStorageUrl(dataPanel[currentIndex].image)}
                                        alt={dataPanel[currentIndex].title}
                                        className="h-full object-cover md:h-[425px] xl:w-[570px] w-[440px]"
                                    />
                                </div>
                            </div>

                            <div className="embla__pagination flex justify-center gap-2 absolute md:bottom-[-40px] bottom-[-25px]">
                                {dataPanel.map((_, index) => (
                                    <button
                                        key={index}
                                        className={`embla__dot rounded-full transition-colors duration-300 ${
                                            currentIndex === index ? 'bg-main w-8 h-3 ' : 'bg-Grey20 w-3 h-3'
                                        }`}
                                        onClick={() => setCurrentIndex(index)}
                                    ></button>
                                ))}
                            </div>

                            {/* Next */}
                            <button
                                onClick={handleNext}
                                className="arrowSlideFooter absolute lg:-right-[27px] md:-right-[23px] right-[0px]"
                            >
                                <IconArrowRightSlide className="iconArrow" />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FooterPanel;
